import { render, staticRenderFns } from "./ListPessoajuridicatipoPage.vue?vue&type=template&id=757551f2&"
import script from "./ListPessoajuridicatipoPage.vue?vue&type=script&lang=js&"
export * from "./ListPessoajuridicatipoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports